import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App";
import { queryClient } from "./clients/ReactQueryClient";
import { UserProvider } from "./context/UserContext";
import { LayoutProvider } from "./context/LayoutContext";
import Devtools from "./components/Devtools/Devtools";

// Create Posthog client
// Performed here to bootstrap feature flag loading regardless if the library has fully loaded.
posthog.init(import.meta.env["VITE_POSTHOG_PUBLIC_KEY"], {
    api_host: import.meta.env["VITE_POSTHOG_HOST"],
    session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
            password: true,
        },
    },
});

// when a deployment occurs then the sourcemap is busted and the user will see an error.  just refresh the page in that case to refetch.
window.addEventListener("vite:preloadError", () => {
    window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
    <QueryClientProvider client={queryClient}>
        <PostHogProvider client={posthog}>
            <UserProvider>
                <LayoutProvider>
                    <App />
                    <Devtools />
                </LayoutProvider>
            </UserProvider>
        </PostHogProvider>
    </QueryClientProvider>,
);
